import $ from 'jquery'
import batchListTemplate from 'templates/batch/list.pug'
import feedbackErrorsTemplate from 'templates/feedback/errors.pug'

import emitter from 'garden/src/js/utils/emitter'

import { showSpinner, hideSpinner } from 'scripts/utils/spinner'
import BaseComponent from 'scripts/components/base-component'

class BatchSearch extends BaseComponent {
  static componentName = 'batch-search'

  static DOMEvents = {
    submit: 'onFormSubmit'
  }

  constructor (element, options = {}) {
    super(element)

    this.options = options
    this.components = {}
  }

  init () {
    this.setupElements()

    this.components.validation = this.$element.data('validation')
  }

  setupElements () {
    this.$output = this.$element.find('[data-batch-list]')
    this.template = batchListTemplate
  }

  onFormSubmit (e) {
    e.preventDefault()

    if (this.components.validation.validateAll()) {
      this.onFetchBatch(
        this.$element.find('[data-batch-number]').val()
      )
    }
  }

  onFetchBatch (batchNumber) {
    showSpinner()

    const { lm, storeSlug, limit } = this.options
    const endpoint = `/hybris/stock/${lm}/${storeSlug}/${batchNumber}`

    $.get(endpoint)
      .always(this.clearErrors)
      .done(this.onFetchBatchSuccess.bind(this))
      .fail(this.onFetchBatchFailure.bind(this))
  }

  onFetchBatchSuccess ({ unit, stores }) {
    hideSpinner()

    emitter.emit('batch-search:success')

    this.clearOutput()

    this.$output.append(this.template({ unit, stores }))
  }

  onFetchBatchFailure ({ responseJSON }) {
    hideSpinner()
    this.clearOutput()
    this.clearErrors()

    const { errors } = responseJSON

    $('[data-batch-errors]').append(feedbackErrorsTemplate({ errors }))
  }

  clearOutput () {
    this.$output.empty()
  }

  clearErrors () {
    $('[data-batch-errors]').empty()
  }
}

export default $el => new BatchSearch($el, $el.data()).init()

export { BatchSearch as Component }
